import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import { bool, number, oneOf, shape, string } from "prop-types";

import apolloClient from "src/shared/utilities/graphql/apolloClient";

import AddToCalendar from "../AddToCalendar";

const App = props => (
  <ApolloProvider client={apolloClient}>
    <AddToCalendar {...props} />
  </ApolloProvider>
);

App.propTypes = {
  isUserLoggedIn: bool,
  listingClass: oneOf(["rental", "sale"]).isRequired,
  listingId: number.isRequired,
  userId: number.isRequired,
  isAgent: bool.isRequired,
  openHouseData: shape({
    id: string,
    listingAddress: string,
    listingLink: string,
    time: shape({
      startsAt: string,
      endsAt: string
    }),
    streamingUrl: string
  }).isRequired,
  openHouseId: number.isRequired,
  showPopoverTooltip: bool
};

App.defaultProps = {
  isUserLoggedIn: false,
  showPopoverTooltip: false
};

export default App;
